import "./App.css";
import { useState, useEffect } from "react";
import { useAuth } from "./contexts/AuthContext";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Modal, Alert } from "react-bootstrap";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LandingPage from "./components/LandingPage";
import Dashboard from "./components/Dashboard";
import Section from "./components/Section";
import Segment from "./components/Segment";
import Resources from "./components/Resources";
import About from "./components/About";
import CEUStatement from "./components/CEUStatement";
import Contact from "./components/Contact";
import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import PaymentPage from "./components/PaymentPage";
import ProfileEditPage from "./components/ProfileEditPage";
import PaymentFailedPage from "./components/PaymentFailedPage";
import AdminDashboard from "./components/admin_dashboard/AdminDashboard";
import Evaluation from "./components/Evaluation";
import { Spinner } from "react-bootstrap";
import LoggedInHeader from "./components/LoggedInHeader";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";

function App() {
  const { currentUser, isLoading } = useAuth();
  const location = useLocation();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [protectedRouteError, setProtectedRouteError] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setProtectedRouteError(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const isSectionPage =
    currentUser &&
    location.pathname !== "/" &&
    !location.pathname.startsWith("/payment") &&
    !location.pathname.startsWith("/profile") &&
    location.pathname !== "/resources" &&
    location.pathname !== "/contact";

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column min-vh-100">
      {protectedRouteError && (
        <Alert
          className="mb-0"
          variant="danger"
          onClose={() => setProtectedRouteError(false)}
          dismissible
          fade
        >
          You are not logged in.
        </Alert>
      )}
      {currentUser ? (
        !isSectionPage && <LoggedInHeader />
      ) : (
        <Header onLoginClick={() => setShowLoginModal(true)} />
      )}
      <main className="flex-grow-1 d-flex flex-column">
        <Routes>
          <Route
            path="/"
            element={
              !currentUser ? (
                <LandingPage onLoginClick={() => setShowLoginModal(true)} />
              ) : !currentUser.profile?.ctg_course_paid ? (
                <Navigate to="/payment" replace />
              ) : !currentUser.profile?.profile_completed ? (
                <Navigate to="/profile/edit" replace />
              ) : (
                <Dashboard />
              )
            }
          />
          <Route path="/about" element={<About />} />
          <Route path="/ceustatement" element={<CEUStatement />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/termsandconditions" element={<TermsAndConditions />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            element={
              <ProtectedRoute setProtectedRouteError={setProtectedRouteError} />
            }
          >
            <Route path="/payment" element={<PaymentPage />} />
            <Route 
              path="/resources"
              element={
                !currentUser?.profile?.ctg_course_paid ? (
                  <Navigate to="/payment" replace />
                ) : (
                  <Resources />
                )
              } 
            />
            <Route path="/payment/error" element={<PaymentFailedPage />} />
            <Route 
              path="/profile/edit" 
              element={
                !currentUser?.profile?.ctg_course_paid ? (
                  <Navigate to="/payment" replace />
                ) : (
                  <ProfileEditPage />
                )
              }
            />
            <Route path="/evaluation" element={<Evaluation />} />
            <Route path="/:sectionSlug" element={<Section />} />
            <Route path="/:sectionSlug/:segmentSlug" element={<Segment />} />
            <Route path="/admin_dashboard" element={<AdminDashboard />} />
          </Route>
        </Routes>
      </main>
      <Footer />
      <Modal show={showLoginModal} onHide={() => setShowLoginModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Login onLoginSuccess={() => setShowLoginModal(false)} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default App;
